@if(pendingOrders!= undefined){
<div class="tw-fixed tw-right-0 tw-z-10 tw-bottom-[var(--header-height)] lg:tw-bottom-0 tw-p-4">
  <div class="tw-flex tw-p-3 tw-aspect-square tw-rounded-full tw-shadow tw-bg-red-600">
    <i routerLink="/panel/order" [title]="pendingOrders+' Pending Order(s)'" severity="warning" pBadge
      class="pi pi-box tw-text-white tw-cursor-pointer tw-text-2xl" [value]="pendingOrders"
      [class.tw-text-3xl]="pendingOrders>0"></i>
  </div>
</div>
}